<template>
  <div class="footer-container">
    <!-- Widget WhatsApp -->
    <div class="whatsapp-widget" :class="{ open: isChatOpen }">
      <div class="whatsapp-button" @click="toggleChat">
        <span class="whatsapp-icon" :style="iconStyle">📱</span>
      </div>
      
      <div v-if="isChatOpen" class="chat-container">
        <div class="chat-header">
          <div class="chat-title">
            <span class="chat-icon">💬</span>
            Suporte WhatsApp
          </div>
          <button class="close-chat" @click="closeChat">×</button>
        </div>
        
        <div class="chat-messages">
          <div class="message bot-message">
            <div class="message-content">
              Olá! Como posso ajudá-lo hoje?
            </div>
            <div class="message-time">{{ currentTime }}</div>
          </div>
        </div>
        
        <div class="chat-input-container">
          <textarea 
            v-model="message" 
            placeholder="Digite sua mensagem..." 
            class="chat-input"
            @keypress.enter.prevent="sendMessage"
            rows="3"
          ></textarea>
          <button class="send-button" @click="sendMessage" :disabled="!message.trim()">
            <span class="send-icon">📤</span>
            Enviar
          </button>
        </div>
      </div>
    </div>
    
    <!-- Footer principal -->
    <footer class="main-footer">
      <div class="footer-content">
        <div class="footer-text">
          © 2024 Empresa. Todos os direitos reservados.
        </div>
        <div class="footer-links">
          <a href="#" class="footer-link">Termos</a>
          <a href="#" class="footer-link">Privacidade</a>
          <a href="#" class="footer-link">Suporte</a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'AppFooter',
  data() {
    return {
      isChatOpen: false,
      message: '',
      iconSize: 1,
      isGrowing: true,
      animationInterval: null,
      currentTime: this.getCurrentTime()
    }
  },
  computed: {
    iconStyle() {
      return {
        transform: `scale(${this.iconSize})`,
        transition: 'transform 0.3s ease'
      }
    }
  },
  methods: {
    toggleChat() {
      this.isChatOpen = !this.isChatOpen;
      if (this.isChatOpen) {
        this.stopAnimation();
      } else {
        this.startAnimation();
      }
    },
    closeChat() {
      this.isChatOpen = false;
      this.startAnimation();
    },
    sendMessage() {
      if (this.message.trim()) {
        const phone = '5585991994652';
        const encodedMessage = encodeURIComponent(this.message.trim());
        const whatsappUrl = `https://wa.me/${phone}?text=${encodedMessage}`;
        
        window.open(whatsappUrl, '_blank');
        
        this.message = '';
        this.closeChat();
      }
    },
    startAnimation() {
      this.animationInterval = setInterval(() => {
        if (this.isGrowing) {
          this.iconSize += 0.1;
          if (this.iconSize >= 1.3) {
            this.isGrowing = false;
          }
        } else {
          this.iconSize -= 0.1;
          if (this.iconSize <= 0.7) {
            this.isGrowing = true;
          }
        }
      }, 300);
    },
    stopAnimation() {
      if (this.animationInterval) {
        clearInterval(this.animationInterval);
        this.animationInterval = null;
        this.iconSize = 1;
      }
    },
    getCurrentTime() {
      const now = new Date();
      return now.toLocaleTimeString('pt-BR', { 
        hour: '2-digit', 
        minute: '2-digit' 
      });
    }
  },
  mounted() {
    this.startAnimation();
    
    setInterval(() => {
      this.currentTime = this.getCurrentTime();
    }, 60000);
  },
  beforeUnmount() {
    this.stopAnimation();
  }
}
</script>

<style scoped>
.footer-container {
  position: relative;
}

/* Widget WhatsApp */
.whatsapp-widget {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  z-index: 1000;
}

.whatsapp-button {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #25d366, #128c7e);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);
  transition: all 0.3s ease;
  border: none;
}

.whatsapp-button:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 25px rgba(37, 211, 102, 0.6);
}

.whatsapp-icon {
  font-size: 1.5rem;
}

.chat-container {
  position: absolute;
  bottom: 80px;
  right: 0;
  width: 350px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.chat-header {
  background: linear-gradient(135deg, #25d366, #128c7e);
  color: white;
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.chat-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
}

.chat-icon {
  font-size: 1.25rem;
}

.close-chat {
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s ease;
}

.close-chat:hover {
  background: rgba(255, 255, 255, 0.2);
}

.chat-messages {
  padding: 1.5rem;
  max-height: 300px;
  overflow-y: auto;
}

.message {
  margin-bottom: 1rem;
}

.bot-message {
  text-align: left;
}

.message-content {
  background: #f7fafc;
  padding: 0.75rem 1rem;
  border-radius: 18px;
  border-bottom-left-radius: 4px;
  font-family: 'Inter', sans-serif;
  color: #2d3748;
  line-height: 1.4;
}

.message-time {
  font-size: 0.75rem;
  color: #718096;
  margin-top: 0.25rem;
  text-align: left;
}

.chat-input-container {
  padding: 1rem 1.5rem;
  border-top: 1px solid #e2e8f0;
}

.chat-input {
  width: 100%;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 0.75rem;
  font-family: 'Inter', sans-serif;
  resize: none;
  margin-bottom: 0.75rem;
  transition: border-color 0.3s ease;
}

.chat-input:focus {
  outline: none;
  border-color: #25d366;
}

.send-button {
  width: 100%;
  background: linear-gradient(135deg, #25d366, #128c7e);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 12px;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.send-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(37, 211, 102, 0.4);
}

.send-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.send-icon {
  font-size: 1.125rem;
}

/* Footer principal */
.main-footer {
  background: #1a202c;
  color: white;
  margin-top: auto; /* Para ficar no final da página */
}

.footer-content {
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: 'Inter', sans-serif;
  max-width: 1200px;
  margin: 0 auto;
}

.footer-text {
  color: #a0aec0;
  font-size: 0.875rem;
}

.footer-links {
  display: flex;
  gap: 2rem;
}

.footer-link {
  color: #cbd5e0;
  text-decoration: none;
  font-size: 0.875rem;
  transition: color 0.3s ease;
}

.footer-link:hover {
  color: white;
}

@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
  
  .footer-links {
    gap: 1rem;
  }
  
  .chat-container {
    width: 300px;
    right: -50px;
  }
  
  .whatsapp-widget {
    bottom: 1rem;
    right: 1rem;
  }
  
  .whatsapp-button {
    width: 50px;
    height: 50px;
  }
}
</style>